// extracted by mini-css-extract-plugin
export default {"logoSettings":"StoreLogo-module--logoSettings--PkBz4"};